/**
 * This component renders the top banner for a Game page
 * Gradient will be different for mobile and desktop views and light/dark mode
 */

import React from "react";
import TabButton from "../core/TabButton";
import { Link } from "react-router-dom";
import { formatFaceoffTimeDate } from "../utils/time.js";

const GameBanner = ({ activeTab, handleTabClick, data }) => {

  console.log("GameBanner data:", data);

  const getGradientStyle = (data) => {
    // Function to convert hex color to rgba
    const hexToRgba = (hex, alpha) => {
      return `rgba(${parseInt(hex.slice(1, 3), 16)}, ${parseInt(
        hex.slice(3, 5),
        16
      )}, ${parseInt(hex.slice(5, 7), 16)}, ${alpha})`;
    };

    // Detect dark mode preference
    const isDarkMode =
      window.matchMedia &&
      window.matchMedia("(prefers-color-scheme: dark)").matches;

    const isDesktop = window.matchMedia("(min-width: 600px)").matches;

    const homeColor = data.home_team ? data.home_team.primary_color : "#222222";
    const awayColor = data.away_team ? data.away_team.primary_color : "#222222";

    // Gradient for dark or light mode
    const background = isDarkMode
      ? // Mode: Dark

        // Mobile dark mode
        !isDesktop
        ? `linear-gradient(to right,
            ${hexToRgba(homeColor, 1)},
            ${hexToRgba(homeColor, 0.5)},
            
            #1b1b1b,#1b1b1b,
            ${hexToRgba(awayColor, 0.5)},
            ${hexToRgba(awayColor, 1)})`
        : // Desktop dark mode
          `linear-gradient(to right,
            ${hexToRgba(homeColor, 1)},
            ${hexToRgba(homeColor, 0.6)},
            ${hexToRgba(homeColor, 0.2)},
            #1b1b1b, #1b1b1b, #1b1b1b, #1b1b1b, #1b1b1b,
            ${hexToRgba(awayColor, 0.2)},
            ${hexToRgba(awayColor, 0.6)},
            ${hexToRgba(awayColor, 1)})`
      : // Light mode mobile
      !isDesktop
      ? `linear-gradient(to right,
        
            ${hexToRgba(homeColor, 0.7)},
            ${hexToRgba(homeColor, 0.2)},
            #F7F7F7, #F7F7F7,
            ${hexToRgba(awayColor, 0.2)},
            ${hexToRgba(awayColor, 0.7)})`
      : // Desktop light mode
        `linear-gradient(to right,
            ${hexToRgba(homeColor, 0.8)},
            ${hexToRgba(homeColor, 0.5)},
            ${hexToRgba(homeColor, 0.3)},
            
            #F7F7F7, #F7F7F7,#F7F7F7, #F7F7F7,#F7F7F7,
            ${hexToRgba(awayColor, 0.3)},
            ${hexToRgba(awayColor, 0.5)},
            ${hexToRgba(awayColor, 0.8)})`;

    // Return the final gradient style
    return { background };
  };

  const gradientStyle = getGradientStyle(data);

  return (
    // Apply the gradient using inline style
    <div
      className="w-full homegradient border-b-2 border-light-3 border-light-3 dark:border-dark-3"
      style={gradientStyle}
    >
      <div className="flex flex-row justify-between items-center rounded-lg">
        <div className="flex flex-col w-full justify-between items-left">
          <div className="flex flex-col w-full justify-center items-center xs:py-1">
            {/* All overview stuff here */}
            <div className="w-full h-full flex flex-col justify-center items-center pt-1">
              {/* Club name*/}
              <div className="flex flex-row justify-center items-center">
                  {data.division ? (<Link to={`/division/${data.division.id}`} className="z-10 group">
                      <p className="text-center max-xs:text-xxs max-md:text-xs text-darken font-light leading-tight px-2 hover:text-buiha-red dark:hover:text-dark-5 transition-colors duration-200 ease-in-out">
                          {data.division.name} {data.status !== "END" ? ` - ${data.location}` : ""} - {formatFaceoffTimeDate(data.date)}
                      </p>
                  </Link>) : <p className="text-center max-xs:text-xxs max-md:text-xs text-darken font-light leading-tight px-2 hover:text-buiha-red dark:hover:text-dark-5 transition-colors duration-200 ease-in-out">&nbsp;</p>}
              </div>
            </div>
              <div className="flex flex-row justify-between items-center w-full 2xl:px-20 px-2 xxs:px-8 max-lg:mb-2">
                  {data.home_team ? (<Link to={`/club/${data.home_team.club}`} className="z-10 group">
                <div className="flex flex-col lg:flex-row items-center xs:min-w-[120px] sm:min-w-[240px]">
                  <img
                    src={`${data.home_team.logo.lg}`}
                    alt={data.home_team.name}
                    className="lg:h-28 lg:w-28 sm:h-24 sm:w-24 h-20 w-20 lg:mr-4 transition-transform duration-300 ease-in-out group-hover:scale-105"
                  />

                  {(data.home_team.team_name === "Varsity Squad" ||
                    data.home_team.team_name === "Select Squad" ||
                    data.home_team.team_name === "Seconds") && (
                    <div className="flex flex-col justify-center lg:justify-start items-center max-lg:mt-1 lg:items-start lg:min-w-[300px]">
                      <p className="flex light:text-white sm:hidden text-lg font-semibold leading-tight transition-colors duration-300 ease-in-out group-hover:text-buiha-red dark:group-hover:text-dark-5 text-center">
                        {data.home_team.club_name}
                      </p>
                      <p className="hidden light:text-white sm:max-lg:flex lg:hidden text-lg md:text-xl font-normal leading-tight transition-colors duration-300 ease-in-out group-hover:text-buiha-red dark:group-hover:text-dark-5">
                        {data.home_team.name}
                      </p>
                      <p
                        className="hidden light:text-white lg:flex text-4xl font-semibold leading-tight lg:text-left transition-colors duration-300 ease-in-out group-hover:text-buiha-red dark:group-hover:text-dark-5"
                        style={{ lineHeight: "1" }}
                      >
                        {data.home_team.club_name}
                      </p>
                      <p className="hidden light:text-white lg:flex text-2xl max-lg:mr-2 font-semibold leading-tight lg:text-left transition-colors duration-300 ease-in-out group-hover:text-buiha-red dark:group-hover:text-dark-5">
                        {data.home_team.team_name}
                      </p>
                    </div>
                  )}

                  {data.home_team.team_name !== "Varsity Squad" &&
                    data.home_team.team_name !== "Select Squad" &&
                    data.home_team.team_name !== "Seconds" && (
                      <div className="flex flex-col justify-center lg:justify-start items-center max-lg:mt-1 lg:items-start lg:min-w-[300px]">
                        <p className="flex light:text-white sm:hidden text-lg font-semibold leading-tight transition-colors duration-300 ease-in-out group-hover:text-buiha-red dark:group-hover:text-dark-5 text-center">
                          {data.home_team.team_name}
                        </p>
                        <p className="hidden light:text-white sm:max-lg:flex lg:hidden text-lg md:text-xl font-normal leading-tight transition-colors duration-300 ease-in-out group-hover:text-buiha-red dark:group-hover:text-dark-5">
                          {data.home_team.name}
                        </p>
                        <p className="hidden light:text-white lg:flex text-2xl max-lg:mr-2 font-semibold leading-tight lg:text-left transition-colors duration-300 ease-in-out group-hover:text-buiha-red dark:group-hover:text-dark-5">
                          {data.home_team.club_name}
                        </p>
                        <p
                          className="hidden light:text-white lg:flex text-4xl font-semibold leading-tight lg:text-left transition-colors duration-300 ease-in-out group-hover:text-buiha-red dark:group-hover:text-dark-5"
                          style={{ lineHeight: "1" }}
                        >
                          {data.home_team.team_name}
                        </p>
                      </div>
                    )}
                </div>
              </Link>) : <div className="flex flex-col lg:flex-row items-center xs:min-w-[120px] sm:min-w-[240px]">
                      <img
                          src="/buiha.png"
                          alt=""
                          className="lg:h-28 lg:w-28 sm:h-24 sm:w-24 h-20 w-20 lg:mr-4 transition-transform duration-300 ease-in-out group-hover:scale-105 grayscale opacity-10"
                      />
                  </div>}
              
              {data.played === 7 || data.played === 6  || data.played === 4  || data.played === 0 || data.played === 5 || data.played === -1 ? (
                <div className="scoreboard grow-0 flex-col justify-center items-center min-w-[120px]">
                  <p className="light:text-white inline-flex text-right text-3xl xs:text-4xl leading-tight mt-1">
                    {data.played_status}
                  </p>
                </div>
              ) : ( <></>
              )
              }
              {data.status !== "UPCOMING" ? (
                <div className="scoreboard grow-0 flex-col justify-center items-center min-w-[120px]">
                  <div className="w-full flex flex-row justify-center items-center">
                    <p className="home_score light:text-white w-20 inline-flex text-right text-3xl xs:text-4xl font-semibold leading-tight">
                      {data.home_score}
                    </p>
                    <p className="inline-flex light:text-white mx-2 sm:mx-5 text-center text-3xl xs:text-4xl font-semibold leading-tight">
                      {" "}
                      -{" "}
                    </p>
                    <p className="away_score light:text-white w-20 inline-flex text-left text-3xl xs:text-4xl font-semibold leading-tight">
                      {data.away_score}
                    </p>
                  </div>
                  { data.played === 2 || data.played === 3 ? (
                    <p className="text-xxs xs:text-xs text-center font-light leading-tight">
                      {data.played_status}
                    </p>
                  ) : (<></>
                  )}
                  {/* Video link */}
                  {data.video ? (
                    <a
                      href={`https://www.youtube.com/watch?v=${data.video}`}
                      className="w-40 mx-auto font-semibold flex flex-row justify-center items-center"
                    >
                      <img
                        src="/assets/icons/video.png"
                        alt="Video Link Icon"
                        className="w-6 h-6"
                        style={
                          window.matchMedia &&
                          window.matchMedia("(prefers-color-scheme: dark)")
                            .matches
                            ? { filter: "brightness(0) invert(1) opacity(0.8)" }
                            : {}
                        }
                      />
                    </a>
                  ) : (
                    
                    <></>
                  )}
                </div>
              ) : ( 
              /* Preview score */
              <></>
            )
              }

              {data.away_team? (<Link to={`/club/${data.away_team.club}`} className="z-10 group">
                <div className="flex flex-col lg:flex-row-reverse items-center xs:min-w-[120px] sm:min-w-[240px]">
                  <img
                    src={`${data.away_team.logo.lg}`}
                    alt={data.away_team.name}
                    className="lg:h-28 lg:w-28 sm:h-24 sm:w-24 h-20 w-20 lg:ml-4 transition-transform duration-300 ease-in-out group-hover:scale-105"
                  />
                  {(data.away_team.team_name === "Varsity Squad" ||
                    data.away_team.team_name === "Select Squad" ||
                    data.away_team.team_name === "Seconds") && (
                    <div className="flex flex-col justify-center lg:justify-start items-center max-lg:mt-1 lg:items-end lg:min-w-[300px]">
                      <p className="flex light:text-white sm:hidden text-lg font-semibold leading-tight transition-colors duration-300 ease-in-out group-hover:text-buiha-red dark:group-hover:text-dark-5 text-center">
                        {data.away_team.club_name}
                      </p>
                      <p className="hidden light:text-white sm:max-lg:flex lg:hidden text-lg md:text-xl font-normal leading-tight transition-colors duration-300 ease-in-out group-hover:text-buiha-red dark:group-hover:text-dark-5">
                        {data.away_team.name}
                      </p>
                      <p
                        className="hidden light:text-white lg:flex text-4xl font-semibold leading-tight lg:text-right transition-colors duration-300 ease-in-out group-hover:text-buiha-red dark:group-hover:text-dark-5"
                        style={{ lineHeight: "1" }}
                      >
                        {data.away_team.club_name}
                      </p>
                      <p className="hidden light:text-white lg:flex text-2xl max-lg:mr-2 font-semibold leading-tight lg:text-right transition-colors duration-300 ease-in-out group-hover:text-buiha-red dark:group-hover:text-dark-5">
                        {data.away_team.team_name}
                      </p>
                    </div>
                  )}

                  {data.away_team.team_name !== "Varsity Squad" &&
                    data.away_team.team_name !== "Select Squad" &&
                    data.away_team.team_name !== "Seconds" && (
                      <div className="flex flex-col justify-center lg:justify-start items-center max-lg:mt-1 lg:items-end lg:min-w-[300px]">
                        <p className="flex light:text-white sm:hidden text-lg font-semibold leading-tight transition-colors duration-300 ease-in-out group-hover:text-buiha-red dark:group-hover:text-dark-5 text-center">
                          {data.away_team.team_name}
                        </p>
                        <p className="hidden light:text-white sm:max-lg:flex lg:hidden text-lg md:text-xl font-normal leading-tight transition-colors duration-300 ease-in-out group-hover:text-buiha-red dark:group-hover:text-dark-5">
                          {data.away_team.name}
                        </p>
                        <p className="hidden light:text-white lg:flex text-2xl max-lg:mr-2 font-semibold leading-tight lg:text-right transition-colors duration-300 ease-in-out group-hover:text-buiha-red dark:group-hover:text-dark-5">
                          {data.away_team.club_name}
                        </p>
                        <p
                          className="hidden light:text-white lg:flex text-4xl font-semibold leading-tight lg:text-right transition-colors duration-300 ease-in-out group-hover:text-buiha-red dark:group-hover:text-dark-5"
                          style={{ lineHeight: "1" }}
                        >
                          {data.away_team.team_name}
                        </p>
                      </div>
                    )}
                </div>
              </Link>) : <div className="flex flex-col lg:flex-row-reverse items-center xs:min-w-[120px] sm:min-w-[240px]">
                  <img
                      src="/buiha.png"
                      alt=""
                      className="lg:h-28 lg:w-28 sm:h-24 sm:w-24 h-20 w-20 lg:ml-4 transition-transform duration-300 ease-in-out group-hover:scale-105 grayscale opacity-10"
                  />
              </div>}
            </div>
          </div>

          {/* Tab switch buttons */}
          {data.status === "END" ? (
            <div className="flex flex-row justify-center items-center">
              <TabButton
                tabName="stats"
                activeTab={activeTab}
                handleTabClick={handleTabClick}
                label="Stats"
                first={true}
              />
              <TabButton
                tabName="preview"
                activeTab={activeTab}
                handleTabClick={handleTabClick}
                label="Preview"
              />
              <TabButton
                tabName="recap"
                activeTab={activeTab}
                handleTabClick={handleTabClick}
                label="Recap"
              />
              <TabButton
                tabName="gamesheet"
                activeTab={activeTab}
                handleTabClick={handleTabClick}
                label="Sheet"
              />
            </div>
          ) : (
            <div className="flex lg:pt-4 flex-row justify-center items-center lg:mb-6"></div>
          )}
        </div>
      </div>
    </div>
  );
};

export default GameBanner;
